import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import Loader from "./Loader";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ConnectionStatusModal = ({
  show,
  onConfirmConnectionStatus,
  onCloseClick,
}) => {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => ({
    isLoading: state.Company.isCompanyUpdateLoading,
  }));

  const handleCloseModal = () => {
    onCloseClick();
  };

  return (
    <Modal
      isOpen={show}
      toggle={handleCloseModal}
      centered={true}
      className="delete-client-modal"
    >
      <ModalBody className="py-3 px-5">
        <div className="d-flex flex-column">
          <p className="text-center pt-4">
            {t("integration.connectionStatusModal.message")}
          </p>
          <div className="d-flex gap-2 justify-content-end mt-4">
            <Button
              type="button"
              className="text-primary"
              color="light"
              onClick={handleCloseModal}
            >
              {t("common.actions.cancel")}
            </Button>
            <Button
              type="button"
              color={"warning text-primary"}
              disabled={isLoading}
              onClick={() => {
                onConfirmConnectionStatus();
                setTimeout(() => {
                  handleCloseModal();
                }, 1500);
              }}
            >
              {isLoading ? (
                <Loader size="sm"></Loader>
              ) : (
                t("common.actions.yes")
              )}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

ConnectionStatusModal.propTypes = {
  onCloseClick: PropTypes.func,
  onConfirmConnectionStatus: PropTypes.func,
  show: PropTypes.any,
};

export default ConnectionStatusModal;
